import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { SynopticLogoCompactIcon } from '@synoptic/ui-kit/icons/react/synoptic-logo-compact.tsx';
import { LayoutCard } from '@/components/layout/card.tsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import {
  cardLeftContainer,
  exploreButton,
  gradientBlock,
  streamPackagesCard,
  streamPackagesDescription,
  streamPackagesHeader,
  streamPackagesImage,
  streamPackagesImageContainer,
  streamPackagesTitle,
} from '@/routes/_app.p.marketplace.streams/stream-packages-card/stream-packages-card.css.ts';
import StreamPackagesImg from '@/routes/_app.p.marketplace.streams/stream-packages-card/stream-packages.png';

export const StreamPackagesCard = () => {
  return (
    <LayoutCard className={streamPackagesCard}>
      <div className={cardLeftContainer}>
        <div className={streamPackagesHeader}>
          <SynopticLogoCompactIcon /> Synoptic recommends
        </div>
        <div>
          <h4 className={streamPackagesTitle}>
            Stream smarter: Unlock exclusive stream packages!
          </h4>
          <p className={streamPackagesDescription}>
            Get more value with curated packages that bundle multiple
            high-quality streams at the best price. Access exclusive content
            from Synoptic or choose a cost-effective package to maximize your
            insights.
          </p>
        </div>
        <Button
          size={'small'}
          variant={'outline'}
          className={exploreButton}
          asChild
        >
          <Link to={paths.streamPackages}>Explore packages</Link>
        </Button>
      </div>
      <div className={streamPackagesImageContainer}>
        <img
          src={StreamPackagesImg}
          alt={'Stream packages'}
          className={streamPackagesImage}
        />
        <div className={gradientBlock} />
      </div>
    </LayoutCard>
  );
};
